module.exports = __webpack_public_path__ + "img/nas-download-icon3.50947a98.png";